export default __webpack_public_path__ + "static/media/gym-img-10.b4cf1c2b.jpg";